import BaseAPI from '@/apis/base/baseApi';
import httpclient from '../base/httpclient';
class TaskLogApi extends BaseAPI {
  apiName = 'Business';
  controllerName = 'TaskLogs';

  /**
   * lấy kết quả thực hiện ghi sổ/ bỏ ghi nhiều chứng từ
   * ntduong2 13.11.2024
   */
  CheckResultPostMulti(task_id) {
    const request = {
      url: [this.getAPIUrl(), '/checkresultpostmulti'].join(''),
      data: {task_id},
    };

    return this.getAsync(request);
  }
}
export default new TaskLogApi();
